/* QUEUE N2c fix 2 (2026-10-06): AN ASSIGN MADE ON THE WEB TOLD THE CLIENT NOTHING.
 *
 * The N2 walk: the phone's assign calls `send-push` (`CoachAssignmentService.notifyClient`); none of the web's six
 * `assign_coach_workout` callers did, and the web is William's only door — so every web assign reached the athlete only if
 * they happened to open the app.
 *
 * ⚠️ ONE ALERT PER ACT, NAMING THE FIRST DAY WRITTEN AND HOW MANY — the phone's rule (`send-push`'s header: three alerts for one
 * act is how an app gets silenced). A block names its PROGRAM (`programId`), because "Push A — 12 days" read as one workout.
 *
 * ⚠️ FIRE AND FORGET, EVERY FAILURE SWALLOWED, like `Inbox.tsx`'s message push: the assignment is already written, and an error
 * here would read as the assign having failed. `send-push` decides authority itself (re-reads the row under the coach's own JWT,
 * narrows to the assignment's coach; a programId is read as the caller too).
 */
import { supabase } from "./supabase";

/** What `send-push` is sent: the first assignment the act wrote, how many days it wrote, and the block's program if any. */
export function assignPushBody(firstAssignmentId: string | null, dayCount: number, programId?: string)
  : { assignmentId: string; dayCount: number; programId?: string } | null {
  if (firstAssignmentId === null || dayCount < 1) return null;   // nothing written → nothing to say
  return programId === undefined
    ? { assignmentId: firstAssignmentId, dayCount }
    : { assignmentId: firstAssignmentId, dayCount, programId };
}

export function tellTheClient(firstAssignmentId: string | null, dayCount: number, programId?: string): void {
  const body = assignPushBody(firstAssignmentId, dayCount, programId);
  if (body === null) return;
  void supabase.functions.invoke("send-push", { body }).catch(() => undefined);
}
